import StepNavBar from 'src/components/StepNavBar';
import useAttachDocument from 'src/hooks/useAttachDocument';
import useEnterInvoices from 'src/hooks/useEnterInvoices';

const EnterInvoiceNavbar = () => {
  const {
    goToPrevStep,
    nextStep,
    disableStep,
    guideMe,
    showPreview,
    setShowPreview,
    currentStep,
    buttonRef,
    setStep,
    setInvoiceNumber,
    isOcrRedirect,
    setSearchPo,
    setAttachId,
    setIsOcrRedirect,
  } = useEnterInvoices();

  const { count } = useAttachDocument();
  const onCompanyChange = () => {
    setStep(1);
    setInvoiceNumber((prev) => ({ ...prev, value: '' }));
    setSearchPo((prev) => ({ ...prev, value: '' }));
    setAttachId('');
    setIsOcrRedirect(false);
  };

  return (
    <StepNavBar
      prevStep={goToPrevStep}
      nextStep={nextStep}
      disableStep={disableStep}
      GuideMe={guideMe}
      docCount={isOcrRedirect ? 1 : count}
      showPreview={showPreview}
      setShowPreview={setShowPreview}
      nextButtonRef={buttonRef}
      hideBackButton={currentStep > 1}
      onCompanyChange={onCompanyChange}
    />
  );
};

export default EnterInvoiceNavbar;
